import { render } from "./InputFC.vue?vue&type=template&id=8807694e"
import script from "./InputFC.vue?vue&type=script&lang=js"
export * from "./InputFC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__